import React, { useEffect, useState } from 'react';
import FilterButton, { FilterGroup } from '../../FilterButton';
import { DateRangeFilterButton } from '../../DateRangeFilterButton';
import format from 'date-fns/format'
import sub from 'date-fns/sub'
import { Button, Spinner } from 'react-bootstrap';

const FilterMapBar = ({sptId, onValidate, isLoading=false}) => {
  const initialStartDate = format(sub(new Date(), {weeks: 1}), 'yyyy-MM-dd')
  const initialEndDate = format(new Date(), 'yyyy-MM-dd')
  const [params, setParams] = useState({
    startDate: initialStartDate,
    endDate: initialEndDate,
    data_type: "locations",
    device_id: sptId
  })
  const validate = () => {
    onValidate(params)
  }

  return (
    <FilterGroup onChange={(e) => {
      setParams({...params, ...e})
    }}>
      <DateRangeFilterButton
        startDate={initialStartDate}
        endDate={initialEndDate}
      />
      <FilterButton
        title={"Data type"}
        options={["locations", "visits", "traces"]}
        selected={params.data_type}
        search={false}
        includeAll={false}
        multi={false}
        name="data_type"/>
      <Button onClick={validate} style={{height: "30px"}}>
        Go!
      </Button>
      { isLoading && <Spinner animation="border" variant="primary" size="sm" /> }
    </FilterGroup>
  )
}

export default FilterMapBar
